module.exports = __webpack_public_path__ + "img/logo-ct-dark.cd73ca3b.png";